import { render, staticRenderFns } from "./BandwidthTab.vue?vue&type=template&id=5c3d9a78&scoped=true&"
import script from "./BandwidthTab.vue?vue&type=script&lang=ts&"
export * from "./BandwidthTab.vue?vue&type=script&lang=ts&"
import style0 from "./BandwidthTab.vue?vue&type=style&index=0&id=5c3d9a78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3d9a78",
  null
  
)

export default component.exports